document.addEventListener('DOMContentLoaded', function () {
    const hamburgerToggle = document.querySelector('.hamburger-toggle');
    const navList = document.querySelector('.oscars-nav-list');

    if (hamburgerToggle && navList) {
        hamburgerToggle.addEventListener('click', function () {
            hamburgerToggle.classList.toggle('active');
            navList.classList.toggle('active');
            document.body.style.overflow = navList.classList.contains('active') ? 'hidden' : '';
        });

        // Close menu when clicking a link
        const navLinks = navList.querySelectorAll('.oscars-nav-link');
        navLinks.forEach(link => {
            link.addEventListener('click', function () {
                hamburgerToggle.classList.remove('active');
                navList.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }
});